<template>
	<div class="cloud-Warning">
		<div id="main_car" style="width:100%; height:33vh; margin-top: 2vh;"></div>
	</div>
</template>

<script>
import * as echarts from 'echarts';
import { lastSevenDayData } from '@/utils/index'
import { getstatisticsTunnelWarning } from '@/public/api.js'
import { WarningData } from '../testData/Warning'

// 引入路由实例
export default {
	name: 'Warning',
	components: {
	},
	data() {
		return {
			lastSevenDays: lastSevenDayData(), // 新增最近七天的日期数组
		}
	},
	computed: {

	},
	mounted() {
		let that = this;
		let hostName = window.location.hostname;

		if (hostName == '127.0.0.1' || hostName == '39.100.79.198' || hostName == 'sd.yongsixinxi.com') {
			this.chartInit(WarningData(this.lastSevenDays));
		} else {
			this.statisticsTunnelWarning();
		}
	},
	methods: {
		// 统计隧道预警
		statisticsTunnelWarning() {
			let that = this;
			getstatisticsTunnelWarning({
			}).then(res => {
				if (res.data.code == 200) {
					let dataDom = res.data.data;
					this.chartInit(dataDom);
				}
			})
		},
		chartInit(dataValue) {
			let color = ['#eeaf18', '#69D4AA', '#ec0c26', '#0caaec']
			let dataObj = {
				year: [],
				data: {
					value: []
				}
			}
			const xAxisData = [];
			dataValue[0].data.forEach(itemDate => {
				xAxisData.push(itemDate.date.slice(-5));
			})

			dataValue.forEach(item => {
				let dayData = [];
				item.data.forEach(itemDate => {
					dayData.push(itemDate.count);
				})

				dataObj.data.value.push({
					name: item.name.slice(0, 2),
					value: dayData
				})
			})

			// 基于准备好的dom，初始化echarts实例
			var myChart = echarts.init(document.getElementById('main_car'));
			// 配置项和数据
			var option = {
				tooltip: {
					trigger: 'axis',
					textStyle: {
						color: '#666'
					}, // 自定义格式化函数：显示真实数据+保留1位小数
					formatter: function (params) {
						// params 是当前鼠标悬浮时的所有系列数据数组
						// 1. 获取 x 轴坐标值（如时间、类别等）
						let xValue = params[0].axisValue;
						// 2. 拼接 tooltip 头部（x轴信息）
						let html = `<div>${xValue}</div>`;

						// 3. 遍历每个系列的真实数据，格式化后拼接
						params.forEach(item => {
							// item.value 是当前系列的真实原始数据（非平均）
							// toFixed(1) 保留1位小数，避免科学计数法
							let formattedValue = Number(item.value).toFixed(1);
							// 拼接：系列名称 + 格式化后的值（可保留默认颜色小圆点）
							html += `<div style="display: flex; align-items: center; margin-top: 4px;">
								<span style="display: inline-block; width: 8px; height: 8px; border-radius: 50%; background: ${item.color}; margin-right: 6px;"></span>
								<span>${item.seriesName}: ${formattedValue}</span>
							</div>`;
						});

						return html;
					}
				},
				legend: {
					data: ['步距', '人员', '车辆', '气体'],
					textStyle: {
						color: 'white'
					},
					icon: 'rect', // 使用矩形标记
					itemHeight: 3, // 控制图例标记的高度（单位：px）
					itemWidth: 16, // 控制图例标记的宽度（单位：px），可选，保持与高度一致或按比例设置
					itemGap: 20 // 调整图例项之间的间距，避免拥挤
				},
				toolbox: {
					show: false,
				},
				calculable: true,
				xAxis: [
					{
						type: 'category',
						boundaryGap: false,
						data: xAxisData,
						axisLabel: {
							interval: 0, // 关键：0表示强制显示所有标签（原1可能会间隔显示）
							color: 'white',
							rotate: 0, // 标签旋转30度，避免横向挤压
							margin: 15, // 增加标签与轴线的距离，防止重叠
							fontSize: 9, // 适当减小字体（根据实际情况调整）
							align: 'center' // 标签旋转后居中对齐
						},
					}
				],
				yAxis: [
					{
						type: 'value',
						// 显示Y轴方向的竖线（网格线）
						splitLine: {
							show: true, // 开启竖线
							lineStyle: {
								color: '#666',
								width: 0.4,
								type: 'solid'
							}
						},
						// 可选：设置Y轴线本身的样式
						axisLine: {
							show: true,
							lineStyle: {
								color: '#ccc',
								width: 0.3,
								type: 'solid'
							}
						}
					}
				],


				series: dataObj.data.value.map((item, index) => ({
					name: item.name,
					type: 'line',
					stack: '总量',
					data: item.value,
					lineStyle: {
						color: color[index] // 深蓝色
					},
					itemStyle: {
						color: color[index] // 气体图例标记颜色
					}
				}))
			};

			// 使用配置项和数据显示图表
			myChart.setOption(option);
		},
	},
	beforeDestroy() {

	}
}
</script>
<style scoped>
.cloud-Warning {
	width: 100%;
	height: 100%;
	text-align: left;



}
</style>